import { URLS, createJurisdictionHeaders } from '@/data';
import { useQuery } from '@tanstack/react-query';

const casinoFreeSpinsQueryKey = ['casino-free-spin-games'];

type CasinoFreeSpinsResponse = {
    data: {
        games: Array<{
            game_id: string;
        }>;
    };
};

const getCasinoFreeSpins = async (): Promise<string[]> => {
    const response = await fetch(`${URLS.CHAMELON_API_URL}/auth/casino/free-spins`, {
        method: 'GET',
        headers: {
            ...createJurisdictionHeaders(),
            JURISDICTION: 'CASH-CASINO',
            'Content-Type': 'application/json',
        },
    });

    const data = (await response.json()) as CasinoFreeSpinsResponse;

    if (!response.ok) {
        throw data;
    }

    // The backend returns games ordered by earliest expiry first.
    return data?.data?.games?.map(game => game.game_id) ?? [];
};

export const useCasinoFreeSpinGameIds = () => {
    return useQuery({
        queryKey: casinoFreeSpinsQueryKey,
        queryFn: getCasinoFreeSpins,
        staleTime: Infinity,
        gcTime: Infinity,
    });
};
